/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react';
import { cilLockLocked } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { accountActions } from '../../actions';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { withMsal } from '@azure/msal-react';

class AppHeaderDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNotificationDialouge: false,
    };
    this.logout = this.logout.bind(this);
    this.copyWinscpKey = this.copyWinscpKey.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.fallbackExecCommand = this.fallbackExecCommand.bind(this);
  }

  logout() {
    localStorage.setItem('userInitiatedLogout', 'true');
    
    const msalInstance = this.props.msalContext?.instance;
    
    if (msalInstance) {
      const accounts = msalInstance.getAllAccounts();
      accounts.forEach(account => {
        msalInstance.setActiveAccount(null);
      });
    }
    
    this.props.logout((error) => {
      if (!error) {
        this.props.navigate('/login');
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('userInitiatedLogout', 'true');
      }
    });
  }

  copyWinscpKey() {
    let login_option = localStorage.login_option;
    let userInfo = localStorage.userInfo;
    let payload = localStorage.payload;
    if (login_option == 'new') {
      if (payload) {
        payload = JSON.parse(payload);
        let userInfo = payload['custom:userInfo'];
        let winscpKey = userInfo.split('###');
        this.copyToClipboard(winscpKey[1]);
      }
    } else if (userInfo) {
      let winscpKey = userInfo.split('###');
      this.copyToClipboard(winscpKey[2]);
    }
  }

  copyToClipboard(textToCopy) {
    navigator.clipboard.writeText(textToCopy).then(
      () => {
        toast.success('Copied to clipboard');
      },
      () => {
        this.fallbackExecCommand(textToCopy);
      }
    );
  }

  fallbackExecCommand(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.select();

    try {
      const success = document.execCommand('copy');
      if (success) {
        toast.success('Copied to clipboard');
      } else {
        toast.success('Copy to clipboard failed');
      }
    } catch {
      toast.success('Copy to clipboard failed');
    } finally {
      document.body.removeChild(textArea);
    }
  }

  render() {
    return (
      <CDropdown variant="nav-item">
        <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
          <img
            src="/images/user-circle.svg"
            style={{ height: '34px', borderRadius: '50%' }}
            alt="avatar"
          ></img>
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">
          <CDropdownHeader className="bg-light fw-semibold py-2">Account</CDropdownHeader>
          <CDropdownItem href="#" onClick={this.logout}>
            <CIcon icon={cilLockLocked} className="me-2" />
            Logout
          </CDropdownItem>
          {/* {
           this.props.displayWinscpOtp?
            <CDropdownItem onClick={this.copyWinscpKey}>
              <CIcon icon={cilQrCode} className="me-2" />
              Copy WinSCP Password
            </CDropdownItem>
            :
            null
          } */}
        </CDropdownMenu>
        <ToastContainer />
      </CDropdown>
    );
  }
}

const mapStateToProps = (state) => {
  const { displayWinscpOtp } = state;
  return { displayWinscpOtp };
};

AppHeaderDropdown.propTypes = {
  logout: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  logout: (callback) => dispatch(accountActions.logout(callback)),
});

export default withMsal(connect(mapStateToProps, mapDispatchToProps)(AppHeaderDropdown));
